export function catchArrayBufferErrors(res: ArrayBuffer): Record<string, any> | ArrayBuffer {
  const decodedResponse = decodeBlobToObject(res);
  return decodedResponse instanceof ArrayBuffer ? res : decodedResponse;
}

export function decodeBlobToObject(value: ArrayBuffer): Record<string, any> | ArrayBuffer {
  try {
    return JSON.parse(new TextDecoder().decode(new Uint8Array(value)));
  } catch (e) {
    return value;
  }
}
